module.exports = __webpack_public_path__ + "static/media/zip-code.01534ae2.svg";